<template>
<w-sliding-popup ref="smartAnalyzerPopup" title="Smart Analyzer" width="800px" @close="onClose">
  <div class="tab-wrapper" slot="content">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="성능 예측" name="performance">
        <w-performance-predict-view :rsc-info-list="rscInfoList" />
      </el-tab-pane>
      <el-tab-pane ref="correlationTab" label="상관분석" name="correlation" v-if="objRscKeyList.length !== 1">
        <w-correlation-analysis-view :rsc-info-list="rscInfoList"/>
      </el-tab-pane>
      <el-tab-pane ref="thresholdTab" label="임계치 가이드" name="threshold">
        <w-threshold-guide-view :rsc-info-list="rscInfoList"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</w-sliding-popup>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import msgUtil from '@/utils/message';
import SmartAnalysisApi from '@/api/common/smart-analysis';
import WPerformancePredictView from './PerformancePredictView';
import WCorrelationAnalysisView from './CorrelationAnalysisView';
import WThresholdGuideView from './ThresholdGuideView';

export default {
  name: 'WResourceSmartAnalyzerPopup',
  components: {
    WPerformancePredictView,
    WCorrelationAnalysisView,
    WThresholdGuideView,
  },
  data() {
    return {
      activeTab: 'performance',
      rscInfoList: [],
    };
  },
  computed: {
    visible() {
      return this.$store.state.smartAnalyzer.showRscPopup;
    },
    objRscKeyList() {
      return this.$store.state.smartAnalyzer.objRscKeyList;
    },
  },
  watch: {
    visible: {
      handler(value) {
        if (value) {
          this.open();
        } else {
          this.close();
        }
      },
    },
  },
  beforeDestroy() {
    if (this.visible) {
      this.close();
    }
  },
  methods: {
    open() {
      this.$refs.smartAnalyzerPopup.open();
      this.loadRscInfo();
      /* TODO IE 이슈 대응 */
      this.$nextTick(() => {
        const thresholdTabEl = this.$refs.thresholdTab;
        const correlationTabEl = this.$refs.correlationTab;
        if (!isEmpty(thresholdTabEl) && thresholdTabEl.$el.style.cssText.indexOf('display: block !important;') >= 0) {
          thresholdTabEl.$el.style.cssText = thresholdTabEl.$el.style.cssText.replace('display: block !important;', 'display: none;');
        }
        if (!isEmpty(correlationTabEl) && correlationTabEl.$el.style.cssText.indexOf('display: block !important;') >= 0) {
          correlationTabEl.$el.style.cssText = correlationTabEl.$el.style.cssText.replace('display: block !important;', 'display: none;');
        }
        /* IE 이슈 대응 */
      });
    },
    close() {
      this.$refs.smartAnalyzerPopup.close();
    },
    onClose() {
      this.rscInfoList = [];
      this.activeTab = 'performance';
      this.$store.dispatch('closeResourceSmartAnalyzerPopup');
    },
    loadRscInfo() {
      SmartAnalysisApi.getPredictTargetRscByObjRscKey(this.objRscKeyList)
        .then((response) => {
          if (response.data.success) {
            this.rscInfoList = response.data.data;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 정보', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 정보', false));
          throw new Error(e);
        });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/ResourceSmartAnalyzerPopup/index.vue